import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	
	{
		path: "/public",
		component: () => import("../views/PublicHome.vue"),
		children: [
			{
				name: "PublicHome",
				path: "",
				component: () => import("../views/PublicHome.vue"),
			},
		],
	}
	,{
		path: "/home",
		component: () => import("../views/Index.vue"),
		children: [
			{
				name: "Home",
				path: "",
				component: () => import("../views/Home.vue"),
			},
		],
	},
	{
		path: "/",
		component: () => import("../views/Login.vue"),
		children: [
			{
				name: "Login",
				path: "",
				component: () => import("../views/Login.vue"),
			},
		],
	},
	{
		path: "/photos",
		component: () => import("../views/Index.vue"),
		children: [
			{
				name: "Photos",
				path: "",
				component: () => import("../views/Photos.vue"),
			},
		],
	},
	{
		path: "/place/:id*",
		component: () => import("../views/Index.vue"),
		props: true,
		children: [
			{
				name: "Place",
				path: "",
				component: () => import("../views/Place.vue"),
			},
		],
	},
	// {
	// 	path: "/details_graph/:id*",
	// 	component: () => import("../views/Index.vue"),
	// 	props: true,
	// 	children: [
	// 		{
	// 			name: "DetailsGraph",
	// 			path: "",
	// 			component: () => import("../views/DetailsGraph.vue"),
	// 		},
	// 	],
	// },
	{
		path: "/forecast_graph/:id*",
		component: () => import("../views/Index.vue"),
		props: true,
		children: [
			{
				name: "ForecastGraph",
				path: "",
				component: () => import("../views/ForecastGraph.vue"),
			},
		],
	},
	{
		path: "/pre_discharge/:id*",
		component: () => import("../views/Index.vue"),
		props: true,
		children: [
			{
				name: "PreDischarge",
				path: "",
				component: () => import("../views/PreDischarge.vue"),
			},
		],
	},
	{
		path: "/lowlevel/:id*",
		component: () => import("../views/Index.vue"),
		props: true,
		children: [
			{
				name: "LowLevel",
				path: "",
				component: () => import("../views/LowLevel.vue"),
			},
		],
	},
	{
		path: "/flood_control/:id*",
		component: () => import("../views/Index.vue"),
		props: true,
		children: [
			{
				name: "FloodControl",
				path: "",
				component: () => import("../views/FloodControl.vue"),
			},
		],
	},
	{
		path: "/admin",
		component: () => import("../views/AdminIndex.vue"),
		children: [
			{
				name: "AdminHome",
				path: "",
				component: () => import("../views/AdminHome.vue"),
			},
		],
	},
	{
		path: "/admin/place/:id*",
		component: () => import("../views/AdminIndex.vue"),
		props: true,
		children: [
			{
				name: "AdminPlace",
				path: "",
				component: () => import("../views/AdminPlace.vue"),
			},
		],
	},
	// {
	// 	path: "/admin/settings",
	// 	component: () => import("../views/AdminIndex.vue"),
	// 	children: [
	// 		{
	// 			name: "AdminSettings",
	// 			path: "",
	// 			component: () => import("../views/AdminSettings.vue"),
	// 		},
	// 	],
	// },
	// {
	// 	path: "/admin/notifications",
	// 	component: () => import("../views/AdminIndex.vue"),
	// 	children: [
	// 		{
	// 			name: "AdminNotifications",
	// 			path: "",
	// 			component: () => import("../views/AdminNotifications.vue"),
	// 		},
	// 	],
	// },
	{
		path: "/mypage",
		component: () => import("../views/AdminIndex.vue"),
		children: [
			{
				name: "Mypage",
				path: "",
				component: () => import("../views/Mypage.vue"),
			},
		],
	},
	{
		path: "/error",
		name: "Error",
		component: () => import("../views/Error.vue"),
	},
	{
		path: "*",
		redirect: "/",
	},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
